import "core-js/modules/es.array.push.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8d56a874"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "swiper"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "title"
};
const _hoisted_5 = {
  class: "txt textOverflowHidden"
};
const _hoisted_6 = {
  class: "text"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "detail"
}, "查看详情", -1));
import { useRouter, useRoute } from 'vue-router';

import { reactive } from 'vue';
export default {
  __name: 'carousel3',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    let carouselItems = reactive([{
      title: '物料管理',
      content: '贵州某检验检测机构，主要的业务包括农药GLP检测、化妆品检测等，在试验和生产的过程中涉及到包括耗材、试剂、标样、动物、仪器设备的采购和使用，而且这些物料因为不同的属性和使用场景往往有不同的采购和管理...',
      bg: require('@/assets/images/Rectangle20.png')
    }, {
      title: '计划书/报告生成',
      content: '检测行业作为一项非常重要的行业，其工作涉及到很多关键性问题，因此在生成计划书和报告时会面临很多困难。这些困难不仅影响着检测行业的发展，也影响着整个社会的发展。下面就来详细介绍一下检测行业线下生成计划...',
      bg: require('@/assets/images/Rectangle21.png')
    }, {
      title: '项目管理',
      content: '在当前的检测行业中，许多项目管理仍然依赖传统的纸质文档和手动操作，而没有充分利用现代化工具和技术来支持项目管理。这种传统的方式存在一系列困难和挑战，阻碍了项目管理的效率和质量提升。',
      bg: require('@/assets/images/Rectangle22.png')
    }, {
      title: '电子实验记录本',
      content: '当前，检测行业在数字化转型和质量管理方面面临一些挑战，例如数据记录不规范、实验数据易丢失、实验报告编制繁琐等问题。因此，电子实验记录本可以有效解决这些问题，并提升检测行业的效率和质量水平。',
      bg: require('@/assets/images/Rectangle23.png')
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(carouselItems), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "swiper-item",
          key: index,
          onClick: $event => _unref(router).push('/solution?active=' + index)
        }, [_createElementVNode("div", {
          class: "img-container",
          style: _normalizeStyle({
            backgroundImage: `url(${item.bg})`
          })
        }, null, 4), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.title), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, _toDisplayString(item.content), 1)]), _hoisted_7])], 8, _hoisted_2);
      }), 128))]);
    };
  }
};